import '../asset/main.css'
import imagecover from '../asset/images/15.png'
import AddIcon from 'remixicon-react/AddCircleLineIcon'
import Close from 'remixicon-react/CloseLineIcon'
import Upload from 'remixicon-react/UploadCloudFillIcon'
import Bin from 'remixicon-react/DeleteBinLineIcon'
import 'react-datepicker/dist/react-datepicker.css';
import { useState } from 'react'
import { useEffect, useRef } from 'react';
import { ref, uploadBytes, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
import { app, storage } from '../firebase'
import { addhome } from '../firebase'
const initialData = [
    {
        nameSkill: "Communication",
    },
    {
        nameSkill: "Leadership",
    },
    {
        nameSkill: "English",
    },
]
export default function EditHomeInfo({ onHideBox }) {

    const handleHideBox = () => {
        onHideBox();
    };
    const [dataSkill, setDataSkill] = useState(initialData)



    const [nameSkill, setNameSkill] = useState('');
    const [progress, setProgress] = useState(0);


    const tbodyRef = useRef(null);



    const addSkill = () => {
        const dataCollection = [
            ...dataSkill,
            {
                nameSkill: nameSkill ? nameSkill : '',
            }
        ]

        setDataSkill(dataCollection)
    }

    useEffect(() => {
        setFormData({
            ...formData,
            skills: dataSkill
        })
    }, [dataSkill])

    const handleDeleteSkill = (index) => {
        const newDataCollab = dataSkill.filter((_, i) => i !== index);
        setDataSkill(newDataCollab);
    };



    const [imgData, setImageData] = useState();
    const [avatar, setAvatar] = useState()

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        setAvatar(file)

        if (file) {
            const reader = new FileReader();

            reader.onload = () => {
                const dataURL = reader.result;
                setImageData(dataURL);

                console.log(imgData)

            };

            reader.readAsDataURL(file);
        }

    };


    const uploadImage = () => {
        if (avatar) {
            const storageRef = ref(storage, `avartar/${avatar.name}`);
            const uploadTask = uploadBytesResumable(storageRef, avatar);

            uploadTask.on(
                'state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done');
                    setProgress(progress);
                },
                (error) => {
                    console.error(error);
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        console.log('File available at', downloadURL);
                        setFormData({
                            ...formData,
                            imagecover: downloadURL
                        })

                    });
                }
            );
        } else {
            console.log('No image selected');
        }
    };


    const [formData, setFormData] = useState();

    const handleInfoHome = () => {
        addhome(formData)
            .then((e) => {
                alert("Successfully!")
            })
            .catch((error) => {
                console.log("ERROR: " + error)
            })
    }


    return (
        <div className="addproject">
            <div className="button-close">
                <div className="wrap-button_close" onClick={handleHideBox}>
                    <Close size={40} color='#585858'></Close>
                </div>
            </div>
            <div className="wrap-addproject">
                <div className="addproject-left">

                    <div className="wrap-addproject-left">

                        <div className="addproject-left_description">
                            <h2>Introduce</h2>
                            <textarea onChange={(value) => {
                                setFormData({
                                    ...formData,
                                    introduce: value.target.value
                                })
                            }} ></textarea>
                        </div>

                        <div className="wrap-button-addfile">
                            <input type="file"
                                onChange={handleFileChange} />

                            <div className="progress-bar" style={{ width: `${progress}%` }}>
                            </div>
                        </div>
                        <div className="addproject-left_uploadimg">
                            <div className="option-image_buttonup" onClick={uploadImage}>
                                <Upload color='#585858' size={34}  ></Upload>
                            </div>
                            <div className="wrap-previewimage">
                                <h2>Image cover</h2>
                                <div className="wrap-previewimage_picture">
                                    <img src={imgData ? imgData : imagecover} alt="" />
                                </div>
                            </div>
                        </div>

                    </div>

                </div>


                <div className="space-addproject"></div>

                <div className="addproject-right">
                    <div className="wrap-addproject-right">
                        <div className="addproject-right_collaborator">
                            <h2>Developer skills</h2>

                            <div className="wrap_header-position-about">
                                <input type="text" onChange={(value) => {
                                    setNameSkill(value.target.value)
                                }} />
                                <div className="option-position_buttonadd" onClick={addSkill}>
                                    <AddIcon size={40} color='#585858'></AddIcon>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="addproject-right_resultadd">
                        <div className="addproject-right_resultadd-wrap">
                            <div className="table-container-home">
                                <table width="100%" border="1" cellpadding="5">
                                    <thead>
                                        <tr>
                                            <th>Experience name</th>
                                            <th>Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody ref={tbodyRef}>
                                        {dataSkill.map((data, index) => (
                                            <tr key={index} className='row-of-collab'>
                                                <td>{data.nameSkill}</td>
                                                <td className='button-bin' onClick={() => { handleDeleteSkill(index) }}><Bin></Bin></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>


                    </div>

                    <div className="wrap-button-addproject" onClick={handleInfoHome}>
                        <input type="button" value="Save" />
                    </div>
                </div>
            </div>
        </div>

    )
}